module.exports = __webpack_public_path__ + "static/media/add-to-photo.2f9db5e8.png";